import { useState } from 'react'
import { usePolling } from '../hooks/usePolling'
import { workersApi } from '../lib/api'
import WorkerGrid from '../components/WorkerGrid'

export default function WorkersPage() {
  const [statusFilter, setStatusFilter] = useState<string>('')

  const { data, loading, refetch } = usePolling({
    fetcher: () => workersApi.list(statusFilter ? { status: statusFilter } : undefined),
    interval: 5000,
  })

  const workers = data?.workers || []

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h1 className="text-2xl font-bold text-gray-900">Workers</h1>
        <div className="flex items-center space-x-4">
          <select
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
            className="border border-gray-300 rounded-md px-3 py-2 text-sm"
          >
            <option value="">All statuses</option>
            <option value="idle">Idle</option>
            <option value="processing">Processing</option>
            <option value="offline">Offline</option>
          </select>
          <button
            onClick={() => refetch()}
            className="px-4 py-2 bg-brand-600 text-white text-sm rounded-md hover:bg-brand-700"
          >
            Refresh
          </button>
        </div>
      </div>

      <div className="bg-white rounded-lg shadow p-4">
        <div className="flex items-center justify-between mb-4">
          <p className="text-sm text-gray-500">
            Showing {workers.length} worker{workers.length !== 1 ? 's' : ''}
          </p>
          <p className="text-sm text-gray-400">
            Auto-refreshing every 5 seconds
          </p>
        </div>
      </div>

      {loading && workers.length === 0 ? (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {[1, 2, 3, 4, 5, 6].map((i) => (
            <div key={i} className="bg-white rounded-lg shadow p-4 animate-pulse">
              <div className="h-4 bg-gray-200 rounded w-3/4 mb-2"></div>
              <div className="h-4 bg-gray-200 rounded w-1/2 mb-4"></div>
              <div className="h-16 bg-gray-200 rounded"></div>
            </div>
          ))}
        </div>
      ) : (
        <WorkerGrid workers={workers} />
      )}
    </div>
  )
}
